var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.status==='success' ? 'green' : _vm.status==='error' ? 'red' : 'grey',"small":""}},[_c('v-sheet',{class:typeof _vm.left==='undefined' ? 'text-center' : 'text-left',attrs:{"min-width":_vm.width-24,"color":"transparent","dark":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }